import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Locales } from 'shared/assets/localization';
import { useSignupUserMutation } from 'shared/hooks/queries/use-signup-user-mutation';
import { QueryParamOptions } from 'shared/lib/react-router-dom';
import { Paths } from 'shared/routes';
import { replaceUrlParams } from 'shared/utils/replace-url-params';

export const useSignup = () => {
  const navigate = useNavigate();
  const { mutateAsync, reset, isPending, error } = useSignupUserMutation();

  const signup = useCallback(
    async ({
      name,
      email,
      password,
      locale,
    }: {
      name?: string;
      email: string;
      password: string;
      locale?: Locales;
    }) => {
      const { isSignup } = await mutateAsync({ name, email, password, locale });
      const path = isSignup
        ? replaceUrlParams(
            Paths.Goals,
            {},
            { [QueryParamOptions.OnboardingPremium]: 'true' },
          )
        : Paths.Goals;
      navigate(path);
    },
    [mutateAsync, navigate],
  );

  return { signup, error, retry: reset, isLoading: isPending };
};
